function getTermHealthHealthClass(americoHealthClass) {
  switch (americoHealthClass) {
    case 'best':
      return 'PP';
    case 'better':
      return 'P';
    case 'good':
    default:
      return 'R';
  }
}

function getHealthClass(americoHealthClass) {
  switch (americoHealthClass) {
    case 'best':
    default:
      return 'PP';
    case 'better':
      return 'P';
    case 'good':
      return 'R';
  }
}

function getOtherHealthClass(americoHealthClass) {
  switch (americoHealthClass) {
    case 'best':
    default:
      return 'P';
    case 'better':
      return 'PP';
    case 'good':
      return 'P';
  }
}

export { getTermHealthHealthClass, getHealthClass, getOtherHealthClass };